<template>
    <div id="ContainerOrders">
        <div class="row">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="isSchedulerDB ? PatientTitle : RegistrationInfo" 
                    v-bind:titlePrefix="$t('Orders.Orders')" 
                    v-bind:titleRef="'titleElementOrdersList'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-3">  
                <MdButton
                    v-bind:Label="$t('Orders.Add')"                 
                    v-bind:ClassProp="this.isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="AddOrder"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_order'">
                </MdButton>
            </div>

            <div class="col-sm-12 col-md-3">  
                <MdSelect
                  v-bind:Label="$t('Orders.Status')"
                  v-bind:Options="OrderStatusList"
                  v-bind:FieldDescription="'name'"
                  v-bind:FieldCode="'value'"
                  v-bind:Model="ModelOrderStatus"
                  v-bind:Multiple="false"              
                  :Input="ChangeDropDownOrderStatus"                 
                  v-bind:Name="'status_select'"
                  id="status_select"
                  />
              </div>

            <div class="col-sm-12 col-md-6 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group">
                        <input 
                            type="text" 
                            class="form-control"
                            v-model="parameter.SearchCriteria"   
                            @keyup.enter="SearchOrders">
  
                        <div class="input-group-append">
                            <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="SearchOrders">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:IsMedicationList="true"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="EditOrder"
                            v-bind:VisibleEditIcon="true"
                            v-bind:FieldsDate="FieldsDateArr"               
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                            :otherIcon="'printer-fill'"
                            :otherIconEvent="ShowReport"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">  
            <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">      
                <b-dropdown-item  href="#" v-on:click="ShowReport()">{{$t('schedulerDB.dropdown.Report')}}</b-dropdown-item>
                <b-dropdown-item v-if="visibleCopyOrder && !isReadOnly"  href="#" v-on:click="CopyOrder()">{{$t('Medication.CopyOrder')}}</b-dropdown-item>
                <b-dropdown-item v-if="visibleCopyOrderDC && !isReadOnly" href="#" v-on:click="CopyDCOrder()">{{$t('Medication.CopyDCOrder')}}</b-dropdown-item>
                <b-dropdown-item v-if="visibleInactiveOrder && !isReadOnly" href="#" v-on:click="InactiveOrders()">{{$t('Medication.InactiveOrder')}}</b-dropdown-item>
            </b-dropdown>          
        </div>
    </div>
</template>

<script>
import Permission from '@/common/Permission'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service'
import Utils from "@/common/utils";
import OrdersService from '@/services/orders.service'

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'OrdersList',

    data() {
        return {
            RegistrationInfo:{},
            PatientInfo:{},
            OptionsRightMenu:{
                visible:true,
                ItemsList:[],
                btnvisible:true,
                itemdisabled: false,
                PatientCode:''         
            },
            isSchedulerDB: false,
            currentAppointmentDB:{
                guid:'',
                activitytypecode:'',
                employee: {
                    firstname:"",
                    lastname:""
                }
            }, 
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            isReadOnly: false,
            visibleCopyOrder: false,
            visibleCopyOrderDC: false,
            visibleInactiveOrder: false,
            ShowMessageIsEmpty: false,
            Loading: true,
            parameter: {
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0 ,
                PatientCode:''             
            },
            items: [],
            selected: [],
            fields: [
                { key: 'issuedDate', sortable: true, label: this.$t('Orders.StartDate'), class: 'text-rigth' },    
                { key: 'orderName', sortable: true, label: this.$t('Orders.Order'), class: 'text-rigth' },    
                { key: 'prescriber', sortable: true, label:this.$t('Orders.Prescriber'), class: 'text-rigth' },       
                { key: 'orderStatus', sortable: true, label:this.$t('Orders.Status'), class: 'text-rigth' },       
                { key: 'internalStatus', sortable: true, label: this.$t('Orders.InternalStatus'), class: 'text-rigth'},       
                { key: 'stopDate', sortable: true, label:this.$t('Orders.StopDate'), class: 'text-rigth' }, 
                { key: 'dateTimeExpired', sortable: true, label:this.$t('Orders.TimeExpired'), class: 'text-rigth' }, 
                { key: 'recordId', sortable: true, label:this.$t('Orders.UID'), class: 'text-rigth' }
            ],
            FieldsDateArr:['startDate','endDate','stopDate'],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            physiciansOrdersOptions: {
                byPassPhysicianSignature: false,
                usePatientDoctorAsPrescriber: false,
                inactiveOrdersAtAnyStatus: false,
                copyActiveOrders: false,
                showAllOrders: false,
                showAllMissedOrders: false
            },
            IsCurrentOrder: false,
            ModelOrderStatus: {value:'ActiveDuration',name: this.$t('MedisList.ActiveDuration')},
            OrderStatusList:EnumService.ClinicalMedicatiosRxStatus,
        }
    },

    methods: {
        AddOrder() {
            this.Mode = "Add";
            if (this.isSchedulerDB) {
                this.$router.push({ name: "Appointments-orders-add", 
                params: { id: this.$route.params.id, actId: this.$route.params.actId } });
            }
            else {
                this.$router.push({ name: "Clinical-orders-add", params: { id: this.$route.params.id } });
            }
        },

        EditOrder(row){       
            this.id = row.recordId.trim();        
            this.Mode = "Edit";
            if (this.isSchedulerDB) {
                this.$router.push({ name: "Appointments-orders-details", 
                params: { recId: this.id, actId: this.$route.params.actId } });
            } else {
                this.$router.push({ name: "Clinical-orders-details", params: { recId: this.id } });
            }
        },

        SearchOrders() {
            this.Loading = true;
            this.$emit('load', this.Loading);
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getOrders();
        },

        ShowReport() {

        },

        async SendCopyOrder(stopPreviousPresc){    
            if (this.physiciansOrdersOptions && this.physiciansOrdersOptions.copyActiveOrders) { 
                await this.getCurrentOrder(stopPreviousPresc)
            
                if (this.IsCurrentOrder) {
                    this.$bvModal.msgBoxConfirm(this.$t('Orders.MsgCurrentOrder'), {
                        title: this.$t('Orders.Orders'),
                        okTitle: this.$t('Shared.Continue'),
                        cancelTitle: this.$t('Shared.BtnCancel'),
                        footerClass: 'p-2',
                        titleClass: 'modal-title modal-type-warning',
                        id:'modal_delete_vitals'
                    })
                    .then(value => {
                        if(value) {
                        this.setCopyOrder(stopPreviousPresc)
                        }
                    })
                } else {
                    this.setCopyOrder(stopPreviousPresc)
                }
            } else {
                this.setCopyOrder(stopPreviousPresc)
            }
        },

        setCopyOrder(stopPreviousPresc) {
            const params = {
                "oldRecordID": this.selected[0].recordId,
                "admissionRecordID": this.$route.params.recordid,
                "stopPreviousPresc": stopPreviousPresc
            }
            OrdersService.CopyOrder(params)
                    .then((response) => {
                        if(response.status == '200'){
                            this.$emit('load', false);
                            this.getOrders();
                            this.showMessage(this.$t('Orders.Orders'),this.$t('Orders.MsgOrderCopied'));
                        }                             
                    })
                    .catch((error) => {   
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    }); 
        },

        async CopyOrder() {
            await this.SendCopyOrder(false)
        },

        async CopyDCOrder() {
            await this.SendCopyOrder(true)
        },

        InactiveOrders() {
            const params = {
                "recordIDList": [ this.selected[0].recordId ]
            }
            
            OrdersService.InactiveOrders(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.$emit('load', false);                        
                        this.getOrders();
                        this.showMessage(this.$t('Orders.Orders'),this.$t('Orders.MsgOrderInactive'));
                    }                             
                })
                .catch((error) => {   
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
        },

        async getPrescriptionCurrent(Action) {
            const params = {
                "PatientCode": this.selected[0].patientCode,  
                "OrderCode": this.selected[0].orderCode,
                "Mode": this.selected[0].mode, 
                "RecordId": this.selected[0].recordId, 
                "Action": Action ? 'COPY_DC' : 'COPY', 
                "StartDateTime": Utils.formatterToISO(this.selected[0].startDateTime, Utils.getDateTimeFormat()), 
                "EndDateTime": Utils.formatterToISO(this.selected[0].endDateTime, Utils.getDateTimeFormat()),
                "Day": this.selected[0].day,
            }

            await OrdersService.IsCurrentOrder(params)
                    .then((response) => {
                        if(response.status == '200'){
                            this.$emit('load', false);
                            this.IsCurrentOrder = response.data 
                        }                             
                    })
                    .catch((error) => {   
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    });

        },

        pageChanged (page) {            
            this.currentPage = page;    
            this.getOrders();     
        },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getOrders();  
        },

        async getOrders() {
            this.items = [];       
            var param = {
                PatientCode:this.$route.params.id,
                PageNumber:this.currentPage,
                PageSize:this.perPage,
                SearchCriteria:this.parameter.SearchCriteria ? this.parameter.SearchCriteria : "",
                Status:this.ModelOrderStatus.value,
            }
            await OrdersService.getAll(param)
                .then((response) => {
                    if (response.status == "200" && response.data && response.data.length > 0) {
                        this.items = response.data; 
                        this.totalRows =  this.items[0].maxRows;  
                        this.items.forEach(function(item) {
                            if (item.issuedDate)	
                                item.issuedDate = Utils.formatterDateToString(item.issuedDate);
                            if (item.stopDate)	
                                item.stopDate = Utils.formatterDateToString(item.stopDate);
                            if (item.dateTimeExpired)	
                                item.dateTimeExpired = Utils.formatterDateTimeToString(item.dateTimeExpired);
                        });      
                    }
                    if(this.items.length === 0){
                        this.ShowMessageIsEmpty = true;
                    }
                    this.Loading = false;
                    this.$emit('load', this.Loading);
                })
                .catch((error) => {
                    this.Loading = false;
                    this.$emit('load', this.Loading);
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected(items) {    
            this.selected = items;
            this.visibleCopyOrder = items.length > 0 ? true : false
            this.visibleCopyOrderDC = items.length > 0 && items[0].rxStatus != 'Inactive' ? true : false
            this.visibleInactiveOrder = this.setVisibilityInactiveOrder(items)
            this.visibleVoid = items.length > 0 && items[0].internalStatus == 'ORDERED' ? true : false
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        setVisibilityInactiveOrder(items) {
            let visibility = false
            
            if (items.length > 0 && items[0].orderStatus != 'Inactive')
                if (items[0].internalStatus == 'TARSCREATED' || this.physiciansOrdersOptions.inactiveOrdersAtAnyStatus)
                    visibility = true;
            
            return visibility
        },

        async getPhysiciansOrdersOptions(){
            await OrdersService.getPhysiciansOrdersOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){                
                        this.physiciansOrdersOptions = response.data[0];
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });        
        },

        ChangeDropDownOrderStatus(v){
            this.ModelOrderStatus = v !== null ? v : {value:"All",name:this.$t('Shared.All')};
            this.getOrders();
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
        },

        async GetPatientByCode(){
            let infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
            }
        },
    },

    async mounted() {
        this.$emit('load', this.Loading);
        this.isSchedulerDB = this.$route.name.includes('Appointments-orders');
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.isSchedulerDB ? EnumService.AppointmentItems : EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isReadOnly = this.$store.state.isPhysiciansOrderEHRReadOnly;

        if (this.isSchedulerDB) {
            await this.getCurrentAppointment()
            await this.GetPatientByCode();
        } else {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }
    
        await this.getPhysiciansOrdersOptions();
        this.getOrders();
    },

    destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
}
</script>